// extracted by mini-css-extract-plugin
module.exports = {"label_container":"AddTodoForm_label_container__662NB","add_button":"AddTodoForm_add_button__1ItkY"};